/* ==========================================================
   PROJECT MICROCOSMOS
   MAIN v4.2 - IMMERSIVE SOVEREIGN ENGINE
   (全画面没入ホールドポータル・回遊ハック搭載決定版)
========================================================== */

document.addEventListener("DOMContentLoaded", () => {
    
    // ==========================================
    // 💡 1. ENTER BUTTON & AUDIO MASTER
    // ==========================================
    const enterButton = document.getElementById("enterButton");
    const loadingScreen = document.getElementById("loading-screen");
    const ambientAudio = document.getElementById("ambientAudio");
    const coinAudio = document.getElementById("coinAudio");
    const soundButton = document.getElementById("soundButton");

    if (enterButton && loadingScreen) {
        enterButton.addEventListener("click", () => {
 
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen().catch(() => {});
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen().catch(() => {});
            }

            if (coinAudio) {
                try { coinAudio.volume = 0.6;
                coinAudio.play().catch(() => {}); } catch(e){}
            }
            if (ambientAudio) {
                try { ambientAudio.volume = 0.4;
                ambientAudio.play().catch(() => {}); } catch(e){}
            }

            loadingScreen.style.transition = "opacity 1.5s ease, visibility 1.5s";
            loadingScreen.style.opacity = "0";
            loadingScreen.style.visibility = "hidden";

            setTimeout(() => {
                document.body.classList.add("hero-phase-start");
            }, 400);
        });
    }

    if (soundButton && ambientAudio) {
        soundButton.addEventListener("click", () => {
            const isMuted = ambientAudio.muted;
            ambientAudio.muted = !isMuted;
            if (coinAudio) coinAudio.muted = !isMuted; 
            soundButton.textContent = isMuted ? "SOUND ON" : "SOUND OFF";
        });
    }

    // ==========================================
    // 💡 2. TIMING SOUND ACCENT SYSTEM (0.45s 静寂タメ)
    // ==========================================
    const fades = document.querySelectorAll(".fade");
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
            if(entry.isIntersecting){
                if(!document.body.classList.contains("hero-phase-start")) return;

                if(!entry.target.classList.contains("show")){
                    entry.target.classList.add("show");
                    
                    if (coinAudio && ambientAudio && !ambientAudio.muted) {
                        setTimeout(() => {
                            try {
                                if (!document.body.classList.contains("portal-transitioning")) {
                                    coinAudio.currentTime = 0; 
                                    coinAudio.volume = 0.35; 
                                    coinAudio.play().catch(() => {});
                                }
                            } catch(e){}
                        }, 450);
                    }
                }
            }
        });
    },{
        threshold: 0.55 
    });
    fades.forEach(section => { if(section) observer.observe(section); });

    // ==========================================
    // 💡 3. CINEMATIC SMOOTH SCROLL (BUTTON & MENU LINK)
    // ==========================================
    const heroScrollButton = document.getElementById("heroScrollButton");
    if(heroScrollButton){
        heroScrollButton.addEventListener("click",(e)=>{
            e.preventDefault();
            const target = document.querySelector("#chapter1");
            if(target) {
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                cinematicSlowScroll(targetPosition, 2600);
            }
        });
    }

    const navItems = document.querySelectorAll(".nav-item");
    navItems.forEach(item => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = item.getAttribute("data-target");
            const targetEl = document.getElementById(targetId);
            if(targetEl) {
                const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
                cinematicSlowScroll(targetPosition, 2400);
            }
        });
    });
    function cinematicSlowScroll(targetPosition, duration) {
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime = null;
        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = easeInOutCubic(timeElapsed, startPosition, distance, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) requestAnimationFrame(animation);
        }
        function easeInOutCubic(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t * t + b; t -= 2;
            return c / 2 * (t * t * t + 2) + b;
        }
        requestAnimationFrame(animation);
    }

    // ==========================================
    // 💡 4. MULTI-COIN 3D ROTATION ENGINE & PORTAL SYSTEM 
    // ==========================================
    try {
        const coinElements = document.querySelectorAll(".flip-coin-inner");
        const sections = document.querySelectorAll(".hero, .chapter");

        const gateUrls = [
            "", 
            "pages/aeternitas.html", // CHAPTER 01: 不変
            "pages/chronos.html",    // CHAPTER 02: 刻
            "pages/aura.html",       // CHAPTER 03: 光芒
            "pages/abyss.html"       // CHAPTER 04: 深淵
        ];
        if (coinElements.length > 0) {
            const coinsData = Array.from(coinElements).map((el, idx) => {
                if (gateUrls[idx]) el.style.cursor = "pointer"; 
                
                return {
                    element: el,
                    mouseX: 0, mouseY: 0,
                    currentX: 0, currentY: 0,
                    autoRotateY: Math.random() * 360,
                    isTransitioning: false,
                    currentScale: 1,
                    targetScale: 1,
                    targetUrl: gateUrls[idx] || null
                };
            });
            sections.forEach((sec) => {
                if(!sec) return;
                sec.addEventListener("mousemove", (e) => {
                    const rect = sec.getBoundingClientRect();
                    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 14;
                    const y = ((e.clientY - rect.top) / rect.height - 0.5) * -14;

                    coinsData.forEach((data) => {
                        if (data.isTransitioning) return; 
                        if (sec.contains(data.element)) {
                            data.mouseX = x; data.mouseY = y;
                        }
                    });
                });
                sec.addEventListener("mouseleave", () => {
                    coinsData.forEach((data) => {
                        if (data.isTransitioning) return;
                        if (sec.contains(data.element)) { data.mouseX = 0; data.mouseY = 0; }
                    });
                });
            });

            coinsData.forEach((data) => {
                if (!data.targetUrl) return;

                data.element.addEventListener("click", (e) => {
                    e.stopPropagation(); 
                    
                    if (data.isTransitioning || document.body.classList.contains("portal-transitioning")) return;

                    data.isTransitioning = true;
                    data.targetScale = 8; 
                    data.mouseX = 0; 
                    data.mouseY = 0;

                    document.body.classList.add("portal-transitioning");

                    if (coinAudio && !ambientAudio.muted) {
                        try {
                            coinAudio.currentTime = 0;
                            coinAudio.volume = 0.7; 
                            coinAudio.play().catch(() => {});
                        } catch(err){}
                    }

                    document.body.style.transition = "background-color 0.85s cubic-bezier(0.25, 1, 0.5, 1)";
                    document.body.style.backgroundColor = "#000000";

                    setTimeout(() => {
                        let immersiveStage = document.getElementById("immersive-gate-stage");
                        if(!immersiveStage) {
                            immersiveStage = document.createElement("iframe");
                            immersiveStage.id = "immersive-gate-stage";
                            immersiveStage.style.position = "fixed";
                            immersiveStage.style.inset = "0";
                            immersiveStage.style.width = "100vw";
                            immersiveStage.style.height = "100vh";
                            immersiveStage.style.border = "none";
                            immersiveStage.style.zIndex = "99999";
                            immersiveStage.style.opacity = "0";
                            immersiveStage.style.transition = "opacity 0.8s cubic-bezier(0.25, 1, 0.5, 1)";
                            
                            // 🔑 【調律】音響(autoplay)に加え、フルスクリーン(fullscreen)の特権を子画面へ委譲
                            immersiveStage.allow = "autoplay; fullscreen"; 
                            
                            document.body.appendChild(immersiveStage);
                        }
                        immersiveStage.src = data.targetUrl;
                        immersiveStage.onload = () => {
                            immersiveStage.style.opacity = "1";
                            setTimeout(() => {
                                data.isTransitioning = false;
                                data.targetScale = 1;
                            }, 1000);
                        };
                    }, 850);
                });
            });

            function animateAllCoins() {
                const time = Date.now() * 0.001;
                coinsData.forEach((data, index) => {
                    if(!data.element) return;

                    if (data.isTransitioning) {
                        data.currentX += (0 - data.currentX) * 0.1;
                        data.currentY += (0 - data.currentY) * 0.1;
                        data.autoRotateY += 2.2; 
                        data.currentScale += (data.targetScale - data.currentScale) * 0.06;
                    } else {
                        data.currentX += (data.mouseX - data.currentX) * 0.05;
                        data.currentY += (data.mouseY - data.currentY) * 0.05;
                        data.autoRotateY += 0.08;
                        data.currentScale += (data.targetScale - data.currentScale) * 0.05;
                    }

                    const modifier = data.isTransitioning ? 0.05 : 1;
                    const breathe = Math.sin(time * 0.8 + index) * 3 * modifier;
                    const floatY = Math.sin(time * 0.6 + index) * -8 * modifier;
                    const rotateZ = Math.sin(time * 0.4 + index) * 1.2 * modifier;
                    data.element.style.transform = `
                        perspective(1400px)
                        translateY(${floatY}px)
                        rotateX(${data.currentY + breathe}deg)
                        rotateY(${data.autoRotateY + data.currentX}deg)
                        rotateZ(${rotateZ}deg)
                        scale(${data.currentScale})
                    `;
                });
                requestAnimationFrame(animateAllCoins);
            }
            animateAllCoins();
        }
    } catch(e){}

    // ==========================================
    // 💡 5. BACKGROUND PARTICLES (星くず) SYSTEM
    // ==========================================
    try {
        const canvas = document.getElementById("air-canvas");
        if(canvas) {
            const ctx = canvas.getContext("2d");
            let pts = [];
            
            function resize() {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
            }
            window.addEventListener("resize", resize);
            resize();
            for(let i=0; i<55; i++) {
                pts.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    r: Math.random() * 1.2 + 0.3,
                    d: Math.random() * 0.4 + 0.1
                });
            }

            function drawParticles() {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = "rgba(245, 223, 156, 0.25)";
                ctx.beginPath();
                pts.forEach(p => {
                    ctx.moveTo(p.x, p.y);
                    ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2, true);
                    p.y -= p.d;
                    if(p.y < -10) p.y = canvas.height + 10;
                });
                ctx.fill();
                requestAnimationFrame(drawParticles);
            }
            drawParticles();
        }
    } catch(e){}

    // ==========================================
    // 💡 6. SCROLL HIGHLIGHT SYSTEM
    // ==========================================
    window.addEventListener("scroll", () => {
        let current = "hero";
        const scrollY = window.pageYOffset;
        
        const allSections = document.querySelectorAll("header, section");
        allSections.forEach(sec => {
            const sectionTop = sec.offsetTop - 300;
            if (scrollY >= sectionTop) {
                current = sec.getAttribute("id");
            }
        });

        navItems.forEach(item => {
            item.classList.remove("active");
            if (item.getAttribute("data-target") === current) {
                item.classList.add("active");
            }
        });
    });

    // 👑 特設ページから送られてくるシグナルを集中管制する
    window.addEventListener("message", (e) => {
        const immersiveStage = document.getElementById("immersive-gate-stage");
        if (!immersiveStage) return;

        // 門を閉じるシグナル
        if (e.data === "close-gate") {
            immersiveStage.style.opacity = "0";
            setTimeout(() => {
                immersiveStage.remove();
                document.body.classList.remove("portal-transitioning");
                document.body.style.backgroundColor = "";
            }, 800);
        } 
        // 👑 【新設】門から別の門（Gate間）への回遊シグナル
        else if (e.data && e.data.type === "navigate-gate") {
            immersiveStage.style.opacity = "0"; // 優雅な暗転
            setTimeout(() => {
                immersiveStage.src = e.data.url;
                immersiveStage.onload = () => {
                    immersiveStage.style.opacity = "1"; // 新世界線の覚醒
                };
            }, 600);
        }
    });
});

/* PROGRESS BAR & PARALLAX SCROLL */
try {
    const progress = document.createElement("div");
    progress.style.position="fixed"; progress.style.left="0"; progress.style.top="0"; progress.style.height="2px";
    progress.style.width="0%";
    progress.style.background="linear-gradient(90deg,#8d6a28,#f4d78a,#8d6a28)"; progress.style.zIndex="9999";
    document.body.appendChild(progress);

    window.addEventListener("scroll",()=>{
        const scrollTop = document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const percent = height > 0 ? (scrollTop / height) * 100 : 0;
        progress.style.width = percent + "%";

        const y = window.scrollY;
        const hero = document.querySelector(".hero");
        if(hero){
            hero.style.backgroundPositionY = -(y * 0.18) + "px";
            const value = Math.max(0, 1 - y / 900);
            hero.style.filter = `brightness(${0.75 + value * 0.25})`;
        }
    });
} catch(e){}